module.exports = __webpack_public_path__ + "img/ics_o_sync_white.302e62ba.svg";